import {
	combineReducers,
	configureStore,
	getDefaultMiddleware,
} from "@reduxjs/toolkit";

// import ReportSlice from  "../features/Reports/ReportSlice";
import AbsenceReportsSlice from "../../ts/components/absence-reports/store/absence-reports-slice";
import ReportSlice from "../../ts/components/attendance-reports/store/attendance-reports-slice";
import SkillEvaluationSlice from "../../ts/components/evaluation-setup/store/evaluation-setup-slice";
import EvaluationsSlice from "../../ts/components/evaluations/store/evaluations-slice";
import FullTimeShiftsSlice from "../../ts/components/full-time-shifts/store/full-time-shifts-slice";
import WorkerSchedulerSlice from "../../ts/components/full-time-worker-scheduler/store/worker-scheduler-slice";
import GATAdminConfigurationSlice from "../../ts/components/gat-admin/store/gat-admin-slice";
import SkillInsightReportSlice from "../../ts/components/insight-dashboard/slices/skill-insight-report-slice";
import WorkerInsightReportSlice from "../../ts/components/insight-dashboard/slices/worker-insight-report-slice";
import ManageJobsSlice from "../../ts/components/jobs/store/jobs-slice";
import JobsMatrixSlice from "../../ts/components/jobs-matrix/store/jobs-matrix-slice";
import MinHoursComplianceReportSlice from "../../ts/components/min-hours-compliance-report/store/min-hours-compliance-report-slice";
import MinHoursNotificationReportSlice from "../../ts/components/min-hours-notification-report/store/min-hours-notification-report-slice";
import ShiftSchedulerSlice from "../../ts/components/scheduler/store/scheduler-slice";
import ShiftDemandSlice from "../../ts/components/shift-demand/store/shift-demand-slice";
import SkillsSlice from "../../ts/components/skills/store/skills-slice";
import SupervisorHomeSlice from "../../ts/components/supervisor-home/store/supervisor-home-slice";
import timeOffBalancesSlice from "../../ts/components/time-off-balances-report/store/time-off-balances-report-slice";
import TransportSlice from "../../ts/components/transport/store/transport-slice";
import WorkerActivitySlice from "../../ts/components/worker-activity/store/worker-activity-slice";
import ManageWorkersSlice from "../../ts/components/workers/store/manage-workers-slice";
import CertificationsSlice from "../../ts/features/certifications/store/certifications-slice";
import NavigationDrawerSlice from "../../ts/features/navigation-drawer/navigation-drawer-slice";
import SkillsMatrixSlice from "../../ts/features/skill-matrix/store/skills-matrix-slice";
import userReducer from "../../ts/features/user/user-slice";
import WorkerEvaluationsSlice from "../../ts/features/web-worker-app/store/web-worker-evaluations-slice";
import WebWorkerSlice from "../../ts/features/web-worker-app/store/web-worker-slice";
import CallLogsSlice from "../../ts/features/worker-requests/call-logs/store/call-logs-slice";
import WorkerRequestsSlice from "../../ts/features/worker-requests/store/worker-requests-slice";

const combinedReducer = combineReducers({
	user: userReducer,
	supervisor: ShiftSchedulerSlice,
	worker: WebWorkerSlice,
	report: ReportSlice,
	absenceReports: AbsenceReportsSlice,
	minHoursNotificationReport: MinHoursNotificationReportSlice,
	minHoursComplianceReport: MinHoursComplianceReportSlice,
	navigationDrawer: NavigationDrawerSlice,
	manageWorkers: ManageWorkersSlice,
	gatAdminConfiguration: GATAdminConfigurationSlice,
	manageJobs: ManageJobsSlice,
	jobsMatrix: JobsMatrixSlice,
	workerRequests: WorkerRequestsSlice,
	callLogs: CallLogsSlice,
	workerInsightReportData: WorkerInsightReportSlice,
	skillInsightReportData: SkillInsightReportSlice,
	certifications: CertificationsSlice,
	skills: SkillsSlice,
	skillsMatrix: SkillsMatrixSlice,
	workerActivity: WorkerActivitySlice,
	timeOffBalancesReport: timeOffBalancesSlice,
	workerScheduler: WorkerSchedulerSlice,
	fullTimeShifts: FullTimeShiftsSlice,
	shiftDemand: ShiftDemandSlice,
	skillEvaluation: SkillEvaluationSlice,
	evaluations: EvaluationsSlice,
	workerEvaluations: WorkerEvaluationsSlice,
	supervisorHome: SupervisorHomeSlice,
	transport: TransportSlice,
});

const rootReducer = (state, action) => {
	if (action.type === "user/logoutUser") {
		return combinedReducer(undefined, action);
	}
	return combinedReducer(state, action);
};

export default configureStore({
	reducer: rootReducer,
	middleware: [...getDefaultMiddleware()],
});
